import React, { useState, useEffect, useContext } from 'react';
import { ActivityContext } from 'state/providers/ActivityProvider';
import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import type { FeelingsMatchRound } from '@monorepo/shared/src/graph/schema-generated-types-student';
import FeelingsMatchRoundLayout from './FMatchRoundLayout';
import { formatSounds } from '@monorepo/shared/src/util/sound-format-util';
import { InstructionButtonContext } from 'state/providers/InstructionsButtonProvider';

interface Props {
  round: FeelingsMatchRound;
}
const FeelingsMatchFinalRound: React.FC<Props> = ({ round }) => {
  const { cards, instructions } = round;
  if (!cards) return null;

  const [{ sounds }, { playSoundFromState, loadAudioAssets }] = useActivityAudio();
  const [, { handleEndOfActivity }] = useContext(ActivityContext);
  const [{ playInstructionFlag, currentInstruction }, { stopInstructions, setCurrentInstruction }] =
    useContext(InstructionButtonContext);

  const [isCardInAnimation, setIsCardInAnimation] = useState<boolean>(false);

  useEffect(() => {
    const cardSounds = cards.map((card) => card.cardTouch);
    const fMatchSounds = formatSounds([
      ...cardSounds,
      instructions?.introduction,
      instructions?.end,
    ]);

    loadAudioAssets(fMatchSounds);
  }, [cards]);

  useEffect(() => {
    setIsCardInAnimation(true);

    setTimeout(() => {
      if (instructions?.introduction.description) {
        playSoundFromState(sounds[instructions.introduction.description]);
        setTimeout(() => {
          setIsCardInAnimation(false);
        }, 5000);
      }
    }, 1000);
  }, [instructions?.introduction]);

  useEffect(() => {
    const playSound = async (currentInstruction) => {
      await playSoundFromState(sounds[currentInstruction], true);
      stopInstructions();
    };
    if (currentInstruction && playInstructionFlag) {
      playSound(currentInstruction);
    }
  }, [playInstructionFlag, currentInstruction]);
  useEffect(() => {
    if (instructions?.introduction?.description) {
      setCurrentInstruction(instructions.introduction.description);
    }
  }, [instructions?.introduction?.description]);

  const handleOnClick = (card) => {
    if (isCardInAnimation) return;
    playSoundFromState(sounds[card.cardTouch.description], true);

    setTimeout(async () => {
      if (instructions?.end) {
        await playSoundFromState(sounds[instructions?.end?.description ?? 0], true);
      }
      handleEndOfActivity();
    }, 1500);
  };
  return <FeelingsMatchRoundLayout cardsRowOne={cards} handleOnClick={handleOnClick} />;
};

export default FeelingsMatchFinalRound;
